import OptimizerEditDto from "./OptimizerEditDto";

export class NearExactTrustKrylovOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {boolean} */
        this.inexact = null;
        /** @type {number} */
        this.tol = null;
    }

    /**
     * @typedef {Object} _NearExactTrustKrylovOptimizerEditDtoProps
     * @property {boolean} inexact
     * @property {number} tol
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _NearExactTrustKrylovOptimizerEditDtoProps} NearExactTrustKrylovOptimizerEditDtoProps
     */
    /**
     * @param {NearExactTrustKrylovOptimizerEditDtoProps} props
     * @returns {NearExactTrustKrylovOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.inexact = props.inexact;
        this.tol = props.tol;
        return this;
    }
}

export default NearExactTrustKrylovOptimizerEditDto;